import { render, staticRenderFns } from "./ViolationDelete.vue?vue&type=template&id=e37a88e6&"
import script from "./ViolationDelete.vue?vue&type=script&lang=ts&"
export * from "./ViolationDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports